import { searchActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { log } from '_services'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [searchActions.quickSearchSuccess]: (state, action) => {
        let result;
        action.payload.entities.results ? result = action.payload.entities.results : result = {};
        return result;
    },
    [searchActions.quickSearchFailure]: (state, action) => {
        log.error('Error performing quick search.  searchStr: ' + action.payload.searchStr + ' error: ' + action.payload.error);
    },
    [searchActions.quickSearchClear]: (state, action) => {
        let result;
        result = {};
        return result;
    },


})


